module.exports = __webpack_public_path__ + "static/media/close.57a3ac6a.svg";